import { MessageSquare } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import MultimessagingDirectoryPage from "./pages/MultimessagingDirectoryPage";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import { FEATURE_MULTIMESSAGING } from "../../utils/UserAccessControlUtils";

const MultimessagingRouter: NavigationLinkProps[] = [
  {
    id: "b3f2a7c1-9d4e-4f8a-b6c2-1e5d3a7f9b0c",
    title: "Multimessaging",
    description: "",
    path: "/multimessaging",
    auth: true,
    sidebar: true,
    icon: MessageSquare,
    component: MultimessagingDirectoryPage,
    requiredFeature: FEATURE_MULTIMESSAGING,
    requiredPermissions: ["ANY"],
    isFeatureFlagged: true,
    requiredFeatureFlag: FeatureFlags.MULTIMESSAGING,
  },
];

export default MultimessagingRouter;
